import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upload0",
  "use": "icon-upload0-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-upload0\"><path d=\"M448 480h448v192H448zM64 576l192 128V618.624h128V533.376H256V448z\" p-id=\"4082\" /><path d=\"M64 65.92h896v64H64zM64 256h896v64H64zM64 832h896v64H64zM885.76 480H960v192h-74.24z\" p-id=\"4083\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-upload0.svg
// module id = fvzx
// module chunks = 120